module.exports = __webpack_public_path__ + "7825c0a3a7b86324864e691439dd824a.png";